import { render, staticRenderFns } from "./ProductSalesHorizBar.vue?vue&type=template&id=1f6b3ae5&"
import script from "./ProductSalesHorizBar.vue?vue&type=script&lang=js&"
export * from "./ProductSalesHorizBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports